module.exports = __webpack_public_path__ + "static/icon2-77bfae271e9ed47da8a94ac7a8f743c7.svg";